import { GatsbyImage, ImageDataLike, getImage } from "gatsby-plugin-image";
import React from "react";

export interface ImageRendererProps {
  image: { localFile: ImageDataLike | null };
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
}
const ImageRenderer = (props: ImageRendererProps) => {
  const { image, alt, className = "", style = {}, imgStyle = {} } = props;
  const { localFile } = image ?? {};
  const imageData = getImage(localFile);
  if (!imageData) return <></>;
  return (
    <GatsbyImage
      image={imageData}
      alt={alt ?? ""}
      className={className}
      style={style}
      imgStyle={imgStyle}
    />
  );
};
export default ImageRenderer;
